<template>
  <div class="TwoItemField">
    <div class="item">
      {{dataInfo.leftLabel}}

      {{moneyFormat(
        pageData[dataInfo.leftKey], 
        dataInfo.leftMoneyFormat
      )}}

      {{dataInfo.leftCompany}}
    </div>
    <div>
      {{dataInfo.rightLabel}}

      {{moneyFormat(
        pageData[dataInfo.rightKey], 
        dataInfo.rightMoneyFormat
      )}}

      {{dataInfo.rightCompany}}
    </div>
  </div>
</template>
<script>
import { toThousands } from '@/utils/index';

export default {
  props: {
    dataInfo: {
      type: Object,
      default: () => ({}),
    },
    pageData: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    moneyFormat(value, flag) {
      if (flag && value) {
        return toThousands(value);
      }
      return value;
    },
  },
};
</script>
<style lang="scss" scoped>
.TwoItemField {
  display: flex;
  margin-top: 20px;
  .item {
    margin-right: 20px;
  }
}
</style>
